import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Button, Card, Col, Row } from 'antd';
import Select from 'react-select';

import { toast } from 'react-toastify';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import {
  addAssigneData,
  fetchOpsUsers,
} from '../../services/api/offline-consult';

const Text = styled.p`
  margin: 0;
  font-family: BrandonText-Medium, Lato, sans-serif;
`;

const SemiboldText = styled(Text)`
  font-family: ProximaNova-Semibold, Lato, sans-serif;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const AddAssigneModal = (props) => {
  const {
    isModalOpen,
    closeAssigneModal,
    requestId,
    fetchTableData,
    allCheckedReqIds,
    addAssigneFlag,
  } = props;
  const [assigneData, setAssigneData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState();

  useEffect(() => {
    fetchOpsUsersData();
  }, []);

  const fetchOpsUsersData = async () => {
    const data = await fetchOpsUsers();
    const allOpsUsers = data.map((user) => {
      return {
        value: user.opsUserId,
        label: user.opsUserName,
      };
    });
    setAssigneData(allOpsUsers);
  };

  function handleSelect(data) {
    setSelectedOptions(data);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedAssigne = assigneData.find(
      (item) => item.value === selectedOptions.value
    );

    if (!selectedAssigne) {
      toast.error('Assigne not found');
      return;
    }

    const body = {
      opsUserId: selectedAssigne.value,
      opsUserName: selectedAssigne.opsUserName,
      requestType: 'Add_Assigne_Details',
      requestId: requestId,
      allCheckedReqIds: allCheckedReqIds,
      addAssigneFlag: addAssigneFlag,
    };

    if (!selectedAssigne.value) {
      toast.error('Please fill all the required fields');
      return;
    }

    const data = await addAssigneData(body);
    if (data.message == 'success') {
      fetchTableData();
      closeAssigneModal();
      toast.success('Assigne Requested Created Successfully');
    }
    if (data.message == 'serverError') {
      toast.error(data.errorMessage);
    }
  };

  return (
    <Modal isOpen={isModalOpen}>
      <ModalHeader className="bg-primary" toggle={() => closeAssigneModal()}>
        {addAssigneFlag === 'addAssigne'
          ? `Assign Request (Request Id: ${requestId})`
          : `Assign Request`}
      </ModalHeader>
      <ModalBody>
        <Card>
          <BodyContainer>
            {addAssigneFlag === 'addBulkAssigne' ? (
              <div>
                <LabelText>Selected Id's:</LabelText>
                {allCheckedReqIds.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </div>
            ) : (
              <div></div>
            )}

            <Row gutter={24}>
              <Col xs={24} md={12}>
                <LabelText>Select Assigne:</LabelText>

                <Select
                  options={assigneData}
                  placeholder="Select user"
                  value={selectedOptions}
                  onChange={handleSelect}
                  isSearchable={true}
                />
              </Col>
            </Row>

            <Row gutter={24} style={{ marginTop: 20 }}>
              <Col xs={24} md={12}>
                <Button
                  type="primary"
                  block
                  style={{ marginRight: 10 }}
                  onClick={(e) => handleSubmit(e)}
                >
                  Add
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Button block onClick={closeAssigneModal}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </BodyContainer>
        </Card>
      </ModalBody>
    </Modal>
  );
};

export default AddAssigneModal;
